// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"822":"fa587b93","947":"96b2a53d"}[chunkId] + ".chunk.css");